import React from "react";
import "./order-button.css";
import { ReactComponent as IconArrowUp } from "../../build/images/Arrow-up.svg";

export default function OrderButton({ direction }) {

  return (
    <button
      type="button"
      className={`order-button ${
        direction ? `order-button--${direction}` : ""
      }`}
    >
      <IconArrowUp
        className={
          direction
            ? `order-button__icon-${direction}`
            : "order-button__icon_display"
        }
      />
    </button>
  );
}
